import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { EntityCardHistoryQueryInterface } from '@zaoblako/shared/common/dtos/history/entity-card-history-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import type { RoomItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-items-page.dto';
import type { RoomPartialUpdateInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-partial-update.dto';
import type { RoomFlatListQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-flat-list-query.dto';
import type { RoomRegistryQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-registry-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoomService extends BaseService {
  protected baseUrl = '/room';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor = (): Observable<CardDescriptorInterface> =>
    this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);

  public findPage(queryParams?: RoomRegistryQueryInterface): Observable<RoomItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<RoomItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findAll(queryParams?: RoomFlatListQueryInterface): Observable<RoomFindInterface[]> {
    return this.http.get<RoomFindInterface[]>(`${this.baseUrl}/flat`, { params: this.objectToHttpParams(queryParams) });
  }

  public findOne(roomId: number): Observable<RoomFindInterface> {
    return this.findById<RoomFindInterface>(roomId);
  }

  public getHistory(roomId: number, queryParams: EntityCardHistoryQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${roomId}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public partialUpdate(roomId: number, body: RoomPartialUpdateInterface): Observable<RoomFindInterface> {
    return this.http.patch<RoomFindInterface>(`${this.baseUrl}/${roomId}`, body);
  }

  public downloadPdf(roomId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${roomId}/pdf`, { responseType: 'blob' });
  }
}
